import { Component } from 'react';
import { Row, Tabs, Col, Card, Spin, Tooltip, Select, Table} from 'antd';
import {WearableImage, StepsWalkImage,BadgeFirstIcon} from '../../assets/images';
import Highstock from 'highcharts/highstock';
import ReactHighcharts from 'react-highcharts';
import { withDsChartTheme } from './../../utils/chartTheme';
import { handleAppError } from '../handlers';
import { PngExportFrame } from '../opdClaims/primitives';
import ContractsManager from '../../managers/ContractsManager';
import { analyticsApi, utilizationApi } from '../../services';
import axios from 'axios';
import { PeriodPicker } from '../common/molecules';
import { Breadcrumb } from '../common/atoms';
import { commaingNumber } from '../../utils';
const Charts = withDsChartTheme(ReactHighcharts.withHighcharts(Highstock));
const TabPane = Tabs.TabPane;
const { Option } = Select;
let token = '';

class Steps extends Component {
  constructor(props) {
      super(props)
      this.state = {
        loading: false,
        data: {},
        contractId :null,
        tabLoading: false,
        dropdownValue: '',
        employeeCountOverall: {filters:[], config: {}},
        baseConfig : {
          filters: [],
          config: {
            chart: {},
            title: {text: '', align: 'left'},
            subtitle: { text: '', align: 'left' },
            xAxis: {},
            yAxis: {},
            credits: {
              enabled: false
            },
            series: []
          }
        }
      }
  }

  componentDidMount () {
    this.fetchContractDetails()   
    this.setState({ loading: true })
  }
 
  fetchCompleteData = (contractId, startDate, endDate) => {
    token = axios.CancelToken.source()
    analyticsApi.getStepsAnalytics({contractId, startDate, endDate, cancelToken: token.token}, 
      (resp)=>{
        const fetchData = resp.data
        const dropdownValue = this.state.isRunningContract ? 'last_30days' : 'contract_period'
        this.setState({ data: fetchData, dropdownValue, loading: false, tabLoading : false })
      },
      (err)=>{
        handleAppError(err)
        this.setState({ loading: false, tabLoading: false })
      })
  }

  componentWillUnmount() {
    token && token.cancel()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.contractId && prevState.contractId !== this.state.contractId) {
      token && token.cancel()
      this.fetchCompleteData(this.state.contractId, this.state.startDate, this.state.endDate)
    }
  }

  fetchContractDetails = () => {
    utilizationApi.fetchContracts(
      {},
      (resp) => {
        var contractObj = new ContractsManager(resp.data, 'Steps');
        const contract = contractObj.formattedData[0]
        const isRunningContract = contract.is_running_contract
        this.setState({ metricObj :  contractObj, isRunningContract, contractId : contract.contract_id, startDate: contract.start_date, endDate: contract.end_date })
      },
      (err) => {
        handleAppError(err);
      }
    );
  };
  
  changeContractId = (contract) => {
    const { contractId }  = this.state
    const { contract_id, is_running_contract, start_date, end_date } = contract
    if (contract_id && contractId !== contract_id) {
      this.setState({
        contractId: contract_id,
        startDate: start_date,
        endDate: end_date,
        isRunningContract: is_running_contract,
        tabLoading: true,
      })
    } else if (contract.text === 'Overall') {
      this.setState({
        contractId: contract_id,
        startDate: start_date,
        endDate: end_date,
        isRunningContract: false,
        tabLoading: false,
      })
    }
  }

  handleChange(e){
    let that = this
    that.setState({ dropdownValue: e })
  }

  renderChartTrends(){
    let that = this
    let a = that.state.dropdownValue
    const data = that.state.data[a] ?? {}
    if(a === "last_30days"){
      return(
        <div>
          {this.renderDaysChart(data)}
        </div>
      )
    }else{
      return(
        <div>
          {this.renderChart(data)}
        </div>
      )
    }    
  }

  renderChart(record){
    let that = this
    let keys = Object.keys(record)
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    let series = Object.values(record)
    baseConfig.config.chart.type = 'line'
    baseConfig.config.yAxis.title = {text: "Steps Count"}
    baseConfig.config.yAxis.allowDecimals = false 
    baseConfig.config.xAxis = {categories: keys
                              }                             
    baseConfig.config.plotOptions = {line: {dataLabels: { enabled: false},enableMouseTracking: true,events: {
            legendItemClick: function () {
                return false; 
            }
        }}}
    baseConfig.config.tooltip = { pointFormatter: function() {
          return "Steps Count: " + "<b>" + commaingNumber(this.y) + "</b>"
        },
        backgroundColor: '#FFFFFF',
        borderColor: '#2563EB'
    } 

    baseConfig.config.series = [{name: 'Steps Count',data: series.map(Number),color: '#2563EB',color1: '#ffffff'}]
    return(
      <div style={{marginTop: 30}}>
        <Charts 
          config={baseConfig.config}/>
      </div>
    )
  }

  renderDaysChart(record){
    let that = this
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    baseConfig.config.chart.type = 'line'
    baseConfig.config.xAxis = {type: 'datetime',
                              dateTimeLabelFormats: {
                                  month: '%d. %b',
                                  year: '%b'
                                }
                              } 
    baseConfig.config.tooltip = { pointFormatter: function() {
                                    return "Steps Count: " + "<b>" + commaingNumber(this.y) + "</b>"
                                  },
                                  backgroundColor: '#FFFFFF',
                                  borderColor: '#2563EB'}     

    baseConfig.config.yAxis.title = {text: "Steps Count"}   
    baseConfig.config.yAxis.allowDecimals = false                     
    baseConfig.config.plotOptions = {line: {dataLabels: { enabled: false},enableMouseTracking: true,events: {
            legendItemClick: function () {
                return false; 
            }
        }}}
    baseConfig.config.series = [{name: 'Steps Count',data: record,color: '#2563EB'}]
    return(
      <div style={{marginTop: 30}}>
        <Charts 
          config={baseConfig.config}/>
      </div>
    )
  }

  getColor(value){
    let color = '#E5E7EB'
    if (value === 'Rare') {
      color = '#BFDBFE'
    }else if(value === 'Occasional'){
      color = '#2563EB'
    }else if(value === 'Frequent'){
      color = '#1E40AF'
    }
    return color
  }

  renderPopoverContent(percentage,text,color,subtext){
    return(
      <div>
        <Row type="flex" justify="start">
          <h5 style={{color: '#9CA3AF'}}>{subtext}</h5>
        </Row>
        <Row type="flex" justify="start" style={{marginLeft: '-5px'}}>
          <h5 style={{color: '#9CA3AF'}}>&nbsp; {text} :<span className="semibold" style={{color: '#ffffff'}}>{percentage}</span></h5>
        </Row>
      </div>
    )
  }

  renderIndustryWiseChart(value){
    let that = this
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    const xkeys = ['Highest Utilization', 'Your Utilization', 'Average Utilization']
    const series = [{ name: 'Highest Utilization', y: 90.3, color: '#D97706' },
                    { name: 'Your Utilization', y: value, color: '#2563EB' },
                    { name: 'Average Utilization', y: 7.8, color: '#D97706' }]
    baseConfig.config.chart= { type: 'column',
                               height: 300
                              } 
    baseConfig.config.tooltip = { pointFormat: '<span style="color:{point.color}">{point.y}%</span>',
                                  style: {color: '#9CA3AF'},
                                  backgroundColor: '#475569',
                                  borderColor: 'none'}                          
    baseConfig.config.yAxis.title = {text: "% Of Total Employees Utilized"}
    baseConfig.config.xAxis = {categories: xkeys
                              } 

    baseConfig.config.series = [{ showInLegend: false,data: series,color: 'white',states: {
                hover: {
                    enabled: false
                }
            }}]
    baseConfig.config.plotOptions = {column: {maxPointWidth: 21,events: {
            legendItemClick: function () {
                return false; 
            }
        }}}
    let a = series
        if (a?.length > 0){
          let b = a.map(a => a.y)
          b = Array.prototype.concat(...b)
          b = b.filter( item => item ) // this will delete undefined from array
          b = b.filter( item => isNaN(item) == false) // this will remove alphanumerics from array
          if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
        }
    return(
      <div style={{marginTop: 15}}>
        <Charts 
          config={baseConfig.config}/>
      </div>
    )
  }

  renderTable(record){
    let that = this
    const columns = [
                      {
                        title: 'Rank',
                        dataIndex: 'rank',
                        key: 'rank',
                        width: 150,
                        render: (text, record, row) => {
                          if(record.rank === 1){
                            return(<img src={BadgeFirstIcon}/>)
                          }else{
                            return(
                              <span className="semibold">{record.rank}</span> 
                            )
                          }
                        }  
                      },
                      {
                        title: 'Name',
                        dataIndex: 'name',
                        key: 'name',
                        render: (text, record, row) => {
                          return(
                            <span className="semibold">{record.name}</span>
                          )
                        }
                      },
                      {
                        title: 'Steps',
                        dataIndex: 'steps',
                        width: 150,
                        key: 'steps',
                        render: (text, record, row) => {
                          return(
                            <span className="semibold block text-right pr-5" style={{color: '#2563EB'}}>{commaingNumber(record.steps ?? 0)}</span>
                          )
                        }
                      },
                    ]
    return(
      <div>
        <PngExportFrame fileName='steps-leaderboard'>
          <Table columns={columns} dataSource={record} pagination={{pageSize: 50}} scroll={{y: 500}} />
        </PngExportFrame>
      </div>
    )
  }

  getTheText = (id, data) =>{
    let tab = data.find(item => item.contract_id === id)
    return tab.text ; 
  }

  render () {
    let that = this
    const { metricObj, isRunningContract, dropdownValue } = that.state
    const formattedData = metricObj ? metricObj.formattedData : null
    
    return(
      <div>
        {(that.state.loading || Object.keys(that.state.data).length === 0 )? <div className="spiner">
          <Spin size="large"/>
        </div> :
        <div>
        <Row>
          <Row>
            {/* Title block left, period control right, so the filter sits with the page identity rather
                than below it where it read as the first row of content. */}
            <div className='flex w-full flex-wrap items-start justify-between gap-ds-4'>
              <div className='flex min-w-0 flex-col'>
                <Breadcrumb
                  list={[
                    { text: 'Analytics', link: '#' },
                    { text: 'Steps', link: '/steps' },
                  ]}
                />
                <h2 className='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl mb-0 mt-1.5'>Steps</h2>
                <p className='text-gray-500 leading-4 text-sm mt-2 mb-0'>Trends based on step count</p>
              </div>
              <PeriodPicker
                list={formattedData}
                loading={true}
                classes='shrink-0'
                currentPage={this.getTheText(this.state.contractId, formattedData)}
                setContract={this.changeContractId}
              />
            </div>
          </Row>
        </Row>
        <div> 
          { that.state.tabLoading ? 
            <div className='spiner'>
              <Spin size="large"/>
            </div>  
            :           
            <div>
              <Row>
                <Col span={12}>
                  <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 15}}>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row type="flex" justify="end" style={{paddingRight: 0,marginTop: 5}}>
                    <h4 className="top-right-delay-label" style={{marginTop: 10}}>Refreshes every <b> 1 hour </b></h4>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  <Card className="health-check-utilization-card" style={{marginBottom: 20, marginRight: 5,minHeight: 550}}>
                    <h3 className="font-semibold">Frequency Of Steps Synced</h3>
                    <Row>
                      <Col span={12}>
                        <h5 style={{color: '#6B7280',marginBottom: 60}}>The data represents the frequency of steps synced.</h5>
                      </Col>
                      <Col span={12}>
                        <Row type="flex" justify="end" className="mt-minus-35">
                          <img src={StepsWalkImage}/>
                        </Row>  
                      </Col>
                    </Row> 
                    <Row>
                      <Col span={24}>
                        <h4 className="semibold" style={{color: '#6B7280'}}><span className="semibold" style={{color: '#2563EB'}}>{ commaingNumber(isRunningContract ? that.state.data.total_last_30days : that.state.data.total_employees) }</span> {isRunningContract ? <span className="semibold" style={{color: '#6B7280'}}>employees have synced steps in the last 30 days out of <span className="semibold" style={{color: '#475569'}}>{commaingNumber(that.state.data.total_employees)}</span> in the contract period</span> : 'employees have synced steps during the contract period'}</h4>
                      </Col>
                    </Row>
                    <Row style={{marginTop: 30}}>
                      <Col span={24}>
                        <a>
                          <svg height="20" width="100%" >
                            <rect x="0" y="5" width="100%" height="12" rx="6" ry="6" style={{fill: this.getColor("Default")}}/>
                            <Tooltip  title={this.renderPopoverContent((that.state.data.rare*100/parseInt(that.state.data.total_last_30days)).toFixed(1) + '%','Walks rarely: ',this.getColor("Rare"),`Walked <=7 days ${isRunningContract ? 'in last 30 days' : 'during contract period'}`)}>
                              <rect x="0" y="5" id="rare_walker_bar" width={that.state.data.rare*100/parseInt(that.state.data.total_last_30days) + '%'} height="12" rx="6" ry="6" style={{fill: this.getColor("Rare")}} />
                            </Tooltip>
                            <Tooltip  title={this.renderPopoverContent((that.state.data.occasional*100/parseInt(that.state.data.total_last_30days)).toFixed(1) + '%', 'Walks occasionally: ',this.getColor("Occasional"),`Walked >7 and <20 days ${isRunningContract ? 'in last 30 days' : 'during contract period'}`)}>
                              <rect id="occasional_walker_bar" x={that.state.data.rare*100/parseInt(that.state.data.total_last_30days) + '%'} y="5" width={that.state.data.occasional*100/parseInt(that.state.data.total_last_30days) + '%'} height="12" rx="6" ry="6" style={{fill: this.getColor("Occasional")}} />
                            </Tooltip>
                            <Tooltip  title={this.renderPopoverContent((that.state.data.frequent*100/parseInt(that.state.data.total_last_30days)).toFixed(1) + '%', 'Walks frequently: ',this.getColor("Frequent"),`Walked >=20 days ${isRunningContract ? 'in last 30 days' : 'during contract period'}`)}>
                              <rect id="frequent_walker_bar" x={(parseInt(that.state.data.rare) + parseInt(that.state.data.occasional))*100/parseInt(that.state.data.total_last_30days) + '%'} y="5" width={that.state.data.frequent*100/parseInt(that.state.data.total_last_30days) + '%'} height="12" rx="6" ry="6" style={{fill: this.getColor("Frequent")}} />
                            </Tooltip>
                            <rect x="0" y="15" id="rare_walker_hover_bar" width={this.state.data.rare*100/parseInt(that.state.data.total_last_30days) + '%'} height="4"  />
                            <rect x={that.state.data.rare*100/parseInt(that.state.data.total_last_30days) + '%'} y="15" id="occasional_walker_hover_bar" width={that.state.data.occasional*100/parseInt(that.state.data.total_last_30days) + '%'} height="4"  />
                            <rect x={(parseInt(that.state.data.rare) + parseInt(that.state.data.occasional))*100/parseInt(that.state.data.total_last_30days) + '%'} y="15" id="frequent_walker_hover_bar" width={that.state.data.frequent*100/parseInt(that.state.data.total_last_30days) + '%'} height="4"  />
                          </svg>
                        </a>
                      </Col>
                      <Col span={24} style={{marginTop: 15}}>
                        <Col sm={8}>
                          <Row type="flex" justify="start">
                            <svg height="10" width="10" style={{marginTop: 10}}>
                              <rect x="0" y="0" width="10" height="12" rx="6" ry="6" style={{fill: this.getColor("Rare")}}/>
                            </svg>
                            <h6 className="web-login-track">Walks rarely</h6>
                          </Row>
                          <Row type="flex" justify="start">
                            <h2 className="number-style">{commaingNumber(that.state.data.rare)}</h2>
                          </Row>
                        </Col>
                        <Col sm={8}>
                          <Row type="flex" justify="start">
                            <svg height="10" width="10" style={{marginTop: 10}}>
                              <rect x="0" y="0" width="10" height="12" rx="6" ry="6" style={{fill: this.getColor("Occasional")}}/>
                            </svg>
                            <h6 className="web-login-track">Walks occasionally</h6>
                          </Row>
                          <Row type="flex" justify="start">
                            <h2 className="number-style">{commaingNumber(that.state.data.occasional)}</h2>
                          </Row>
                        </Col>
                        <Col sm={8}>
                          <Row type="flex" justify="start">
                            <svg height="10" width="10" style={{marginTop: 10}}>
                              <rect x="0" y="0" width="10" height="12" rx="6" ry="6" style={{fill: this.getColor("Frequent")}}/>
                            </svg>
                            <h6 className="web-login-track">Walks frequently</h6>
                          </Row>
                          <Row type="flex" justify="start">
                            <h2 className="number-style">{commaingNumber(that.state.data.frequent)}</h2>
                          </Row>
                        </Col>
                      </Col>  

                    </Row>
                    <Card style={{marginTop: 20,border: 0,backgroundColor: '#EFF6FF',borderRadius: 8}}>
                      <Row>
                        <Col span={14}>
                          <h4 className="font-semibold" style={{fontSize: 20,color: '#2563EB'}}>Encourage Employees to sync their wearable on ekincare</h4>
                          <h5 style={{fontSize: 14,color: '#2563EB'}}>Please reach out to <span className="semibold" style={{color: '#2563EB'}}>{sessionStorage.getItem('hr_contact_email')}</span> to learn more</h5>
                        </Col>
                        <Col span={10}>
                          <Row type="flex" justify="end">
                            <img src={WearableImage}/>
                          </Row>  
                        </Col>
                      </Row>
                    </Card> 
                  </Card>
                </Col>
                <Col span={12}>
                  <Card className="health-check-utilization-card" style={{marginBottom: 20,marginLeft: 5,minHeight: 550}}>
                    <h3 className="font-semibold">Total Employees Who Utilized Steps By Industry</h3>
                    <h5 style={{color: '#6B7280',marginBottom: 80}}>Data shows how you compare to other companies basis step utilization</h5>
                    {this.renderIndustryWiseChart(that.state.data.utilization_percentage)}
                  </Card>
                </Col>
              </Row>
              <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 60}}>
                <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 0}}>STEPS TRENDS</h4>
              </Row>
              <Card className="health-check-utilization-card" style={{marginBottom: 20,marginTop: 10}}>
                <Row type="flex" justify="end">
                  <Select 
                    value={dropdownValue}
                    style={{ width: 200, backgroundColor: '#fff' }} 
                    onChange={this.handleChange.bind(this)}
                    >
                    {isRunningContract && <Option value="last_30days">Last 30 Days</Option>}
                    <Option value="contract_period">Contract Period</Option>
                  </Select>
                </Row>
                {this.renderChartTrends()}
              </Card>
              <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 60}}>
                <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 0}}>LEADERBOARD</h4>
              </Row>
              <Row>
                <Col span={24}>
                  { isRunningContract ?
                    <Tabs defaultActiveKey="1" >     
                      <TabPane tab="This Week" key="2">
                        {this.renderTable(that.state.data.this_week)}
                      </TabPane>
                      <TabPane tab="This Month" key="3">
                        {this.renderTable(that.state.data.this_month)}
                      </TabPane>
                      <TabPane tab="This Contract Period" key="4">
                        {this.renderTable(that.state.data.overall)}
                      </TabPane>
                    </Tabs>  
                    :
                    <div className='mt-3'> {this.renderTable(that.state.data.overall)} </div>
                  }
                  </Col>
                </Row>
            </div>
          }  
         </div> 
        </div>
        }
      </div>  
    )
  }
}

export default Steps;